import React, { useState } from "react";

const PreWithCopy = ({ text }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset message after 2s
      })
      .catch((err) => console.error("Copy failed", err));
  };

  return (
    <div style={{ position: "relative" }}>
      <button
        onClick={handleCopy}
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          padding: "5px 10px",
          cursor: "pointer",
        }}
      >
        {copied ? "Copied!" : "Copy"}
      </button>

      <pre
        style={{
          background: "#f4f4f4",
          padding: "20px",
          borderRadius: "5px",
          overflowX: "auto",
        }}
      >
        {text}
      </pre>
    </div>
  );
};

export default PreWithCopy;
